export default __webpack_public_path__ + "static/media/walkin-member.fdae8380.svg";